import script from "./FloatMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./FloatMenu.vue?vue&type=script&setup=true&lang=js"

import "./FloatMenu.vue?vue&type=style&index=0&id=892cecf6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-892cecf6"]])

export default __exports__